import React, { useState } from "react";
import Modal from "@/app/core/layouts/main/components/CustomModal";
import { PhoneController } from "@/app/core/base/controllers/PhoneController";
import Storage from "@/app/core/util/Storage";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import { useEffect } from "react";
import { CardsController } from "@/app/core/base/controllers/CardsController";
import CreditCardModal from "../charge/CreditCardModal";
import { toast } from "react-toastify";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { PaymentController } from "@/app/core/base/controllers/PaymentController";
import { DeliveryController } from "@/app/core/base/controllers/DeliveryController";
import { CurrencyConverter, CurrencyOption, MoneyMask, ProcessCurrency, ProcessOnlyValue, ProcessValue } from "@/app/core/util/helpers/MoneyHelper";
import { TimelineController } from "@/app/core/base/controllers/TimelineController";
import { PartnerHelper } from "@/app/core/util/helpers/PartnerHelper";
import { HandleErrors } from "@/app/core/util/helpers/ErrorHelper";
import DeliveryHelper from "@/app/core/util/helpers/DeliveryHelper";

export default function ConfirmationModal({ show, onHide, delivery, endPayment, nationalCarrier, internationalCarrier }) {
    const date = new Date();
    const [change, setChange] = useState(date.getTime());
    const userData = Storage.getUserData();
    const [data, setData] = useState(PhoneController.BaseModel);
    const [cards, setCards] = useState([]);
    const [type, setType] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show) {
            loadCreditCards();
            loadType()
        }
        console.log("Entrega completa", delivery);
    }, [delivery, show])

    function loadType() {
        if (userData.type == 0) {
            setType(0);
        } else {
            setType(1);
        }
    }

    function notifyChange() {
        setChange(date.getTime());
    }

    function loadCreditCards() {
        CardsController.List(res => setCards(res));
    }

    async function confirmRequest() {

        let base = delivery;
        base.currency = CurrencyConverter(Storage.getCurrency());
        delete base.origin.lat;
        delete base.origin.lng;
        delete base.destination.lat;
        delete base.destination.lng;
        delete base.quotationId;

        if (internationalCarrier && internationalCarrier.partner) {
            base.partner = internationalCarrier.partner;
            base.fedexPickupType = internationalCarrier.pickupType;
            base.fedexServiceType = internationalCarrier.fedexServiceType;
            base.fedexPackagingType = internationalCarrier.packagingType;
            base.deliveryType = internationalCarrier.deliveryType;
            base.currencyRate = internationalCarrier.currencyRate;
            base.term = internationalCarrier.transit_days;
            base.taxCost = internationalCarrier.tax_final;

            console.log("CurrencyRate", base.currencyRate);

            if (delivery.broker != undefined && delivery.broker.name) {
                const oldBroker = { ...base.destination, ...delivery.broker };
                base.broker = oldBroker;
                delete base.broker.lat;
                delete base.broker.lng;

                if (delivery.broker.country != base.destination.country) {
                    if (window.confirm("O broker selecionado não está registrado no país de destino. Deseja continuar?")) {
                        base.broker.country = base.destination.country;
                    } else {
                        toast.info("Voltando a página anterior");
                        onHide();
                        return;
                    }
                }
            } else {
                delete base.broker;
            }

            base.totalPrice = internationalCarrier.totalPrice;
            base.customTotalPrice = internationalCarrier.customTotalPrice;
            if (internationalCarrier.customTotalPrice == internationalCarrier.totalPrice) {
                delete internationalCarrier.customTotalPrice;
            }
        }

        console.log("O que estamos enviando", base);

        base.userId = userData.id;
        if (base.origin.neighborhood == undefined) {
            base.origin.neighborhood = "";
        }
        if (base.destination.neighborhood == undefined) {
            base.destination.neighborhood = "";
        }


        setLoading(true);

        if (base.origin.country == base.destination.country) {
            base.invoiceId = nationalCarrier.id;
            base.quotationId = nationalCarrier.id;
            base.description = nationalCarrier.name;
            base.partner = nationalCarrier.partner;
            if (nationalCarrier.partner == PartnerHelper.Partner.Correios) {
                base.correiosCodServico = nationalCarrier.coProduto;
            }
            // base.boxes = [{
            //     price: delivery.declaredValue,
            //     depth: delivery.depth,
            //     height: delivery.height,
            //     width: delivery.width,
            //     weight: delivery.weight,
            //     name: "Caixa-1",
            // }];
        } else {
            base.invoiceId = internationalCarrier.quotationId;
            base.quotationId = internationalCarrier.quotationId;
            base.origin.federal_tax_id = userData.document;

            base.carrierCode = internationalCarrier.code;
            base.description = internationalCarrier.name;
            base.partner = internationalCarrier.partner;

            if (userData.type == 1) {
                base.type = "pj";
            } else {
                base.type = "pf";
            }

            base.currency = CurrencyConverter(Storage.getCurrency());
            for (let s in base.boxes) {

                base.boxes[s].currency = CurrencyConverter(Storage.getCurrency());
                if (base.boxes[s].items != null && base.boxes[s].items != undefined) {
                    for (let i in base.boxes[s].items) {
                        base.boxes[s].items[i].currency = CurrencyConverter(Storage.getCurrency());
                    }
                }
            }
            console.log("Pegou cotação", base);
        }

        if (base.boxes && base.boxes.length > 0) {
            for (let s in base.boxes) {
                let theBox = base.boxes[s];
                base.boxes[s].id = base.boxes[s].id + "";
                if (theBox.items && theBox.items.length > 0) {
                    for (let y in theBox.items) {
                        base.boxes[s].items[y].unitValue = base.boxes[s].items[y].unit_value;
                        base.boxes[s].items[y].boxId = base.boxes[s].id;
                        base.boxes[s].items[y].box_id = base.boxes[s].id;

                        if (base.boxes[s].items[y].countryCode == undefined) {
                            base.boxes[s].items[y].countryCode = base.origin.country;
                        }
                    }
                }
            }
        }

        //Checando se é um documento e para a ShipSmart
        if (internationalCarrier && internationalCarrier.partner == PartnerHelper.Partner.Shipsmart) {
            if (internationalCarrier.object == "doc") {
                for (let s in base.boxes) {
                    delete base.boxes[s].items;
                }

                base.type = "simple";
            } else {
                base.type = "Commercial";
            }

            base.origin.street = base.origin.addressLine1;
            base.destination.street = base.destination.addressLine1;
        }


        if (type == 0) {
            let selected = cards.filter(x => x.selected == true);
            if (selected.length == 0) {
                toast.error(Message.Payment.SelectOne);
            } else if (data.cvv == "" || data.cvv == undefined || data.cvv.length != 3) {
                toast.error(Message.Payment.InvalidCvv);
            } else {
                if (internationalCarrier && internationalCarrier.partner) {
                    base.partner = internationalCarrier.partner;
                }
                console.log("Enviando para a Total", base);
                if (delivery.id == undefined) {
                    await DeliveryController.Insert(base, async (res) => {
                        console.log("Enviou a entrega", base);
                        timeline(res.id, `Pedido de entrega criado`);
                        if (type == 0) {
                            let payment = { cardId: {} };
                            console.log("Pagamento do cartão", selected);
                            payment.cardId.cardId = selected[0].id;
                            payment.cardId.cardCvv = data.cvv;
                            payment.paymentMethod = "credit_card";
                            payment.deliveryId = res.id;
                            console.log("Pagamento do cartão", payment);

                            // reportDelivery({ ...delivery, ...res });

                            await processPayment(res, payment)
                        } else {
                            await startDelivery(res)
                            await timeline(res.id, `Pedido faturado`);
                        }
                    }, error => {
                        if (error && error.response && error.response.data && error.response.data) {
                            for (let s in error.response.data) {
                                const item = error.response.data[s];
                                console.log("tratamento", item);
                                toast.error(item[0].message);
                            }
                        } else {
                            toast.error(HandleErrors(error));
                        }
                    })
                } else {
                    if (type == 0) {
                        console.log("Tentando de novo");
                        let payment = { cardId: {} };
                        payment.cardId.cardId = selected[0].id;
                        payment.cardId.cardCvv = data.cvv;
                        payment.paymentMethod = "credit_card";
                        payment.deliveryId = delivery.id;
                        console.log("Pagamento cartão", payment);

                        await processPayment(delivery, payment)
                    } else {
                        console.log("Começando direto", delivery);
                        await startDelivery(delivery)
                    }
                }
            }
        } else {
            console.log("Enviando para a Total", base);
            if (internationalCarrier && internationalCarrier.partner) {
                base.partner = internationalCarrier.partner;
            }
            await DeliveryController.Insert(base, async (res) => {
                await startDelivery(res);
            }, error => {
                if (error && error.response && error.response.data && error.response.data) {
                    for (let s in error.response.data) {
                        const item = error.response.data[s];
                        console.log("tratamento", item);
                        toast.error(item[0].message);
                    }
                } else {
                    toast.error(HandleErrors(error));
                }
            });
        }
        setLoading(false);
    }

    function timeline(deliveryId, description) {
        TimelineController.Insert({ deliveryId: deliveryId, description: description, show: true }, result => { })
    }

    async function processPayment(deliveryResult, card) {
        await PaymentController.Payment(card, res => {
            timeline(res.id, `Pagamento em processamento. ID#${res.id}`);
            toast.success(Translate(Message.OrderDone));
            // startDelivery(deliveryResult);
            onHide()
        }, error => console.log("Erro de pagamento", error))
    }

    async function startDelivery(deliveryResult) {
        setLoading(true);
        let deliveryData = {
            "deliveryId": deliveryResult.id,
            "type": "Commercial",
        }
        await DeliveryController.Start(deliveryResult.id, deliveryData, res => {

            TimelineController.Insert({ deliveryId: res.id, show: true, description: `Entrega registrada` }, result => { });
            setLoading(false);

            //Check Schedule
            if (delivery.origin.country != delivery.destination.country && delivery.collectionDate != undefined && delivery.collectionDate != "" && data.collectionDate != "0001-01-01T00:00:00") {
                let value = delivery.collectionDate.split("-");
                const info = `${value[1]}/${value[2]}/${value[0]}`;
                console.log("Data", info);
                toast.success(Translate(Message.OrderDone));
                endPayment()
            } else {

                toast.success(Translate(Message.OrderDone));
                endPayment()
            }

        }, error => {
            setLoading(false);
            if (error && error.response && error.response.data && error.response.data) {
                console.log("tratamento", error.response.data);
                for (let s in error.response.data) {
                    const item = error.response.data[s];
                    // toast.error(item[0].message);
                    // console.log("tratamento", item);
                }
            } else {
            }
            toast.error(HandleErrors(error));
        })
    }

    function selectCard(index) {
        let list = cards;
        for (let s in list) {
            if (s == index) {
                list[s].selected = true;
            } else {
                list[s].selected = false;
            }
        }

        setCards(list);
        fieldChange();
    }


    function fieldChange() {
        setChange(date.getTime());
    }


    function handleChange(evt, type) {
        setData(OnDataChange(data, evt, type))
    }

    return (
        <Modal
            title="Confirmar pedido"
            show={show}
            onHide={onHide}
            isLoading={loading}
            onSubmit={() => confirmRequest()}>
            <div className="block-content row">
                <div className="col-6">
                    <h3 className="font-w700">{Translate(Message.Payment.PaymentType)}:</h3>
                </div>
                {/* {userData.type != 0 ? */}
                <div className="col-6">
                    <select className="form-control" value={type} onChange={evt => setType(parseInt(evt.target.value))}>
                        <option value={0}>{Translate(Message.Payment.Card)}</option>
                        <option value={1}>{Translate(Message.Payment.Billed)}</option>
                    </select>
                </div>
                {/* :""} */}
                {type == 0 ?
                    <div className="col-12">
                        <div className="row">
                            <span className="col-12">{Translate(Message.Payment.SelectOne)}:</span>

                            {change && cards && cards.map((item, index) => (
                                <div className="col-md-4 js-appear-enabled animated fadeIn">
                                    <a className={`block block-rounded block-fx-pop border-3x block-bordered ${item.selected == true ? "border-success" : ""}`} href="javascript:void(0)" onClick={() => selectCard(index)}>
                                        <div className="block-content block-content-full ribbon ribbon-dark ribbon-modern">
                                            <div className="py-3 text-center">
                                                <i className="fa fa-credit-card fa-4x text-gray"></i>
                                                <p className="text-muted mb-3">
                                                    {item.brand}
                                                </p>
                                                <p className="font-size-sm font-w700 text-muted mb-0">
                                                    **** **** **** {item.lastFourDigits}
                                                </p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ))}
                            <div className="col-md-4 js-appear-enabled animated fadeIn" onClick={() => setShowModal(true)}>
                                <a className="block block-rounded block-fx-pop" href="javascript:void(0)">
                                    <div className="block-content block-content-full ribbon ribbon-dark ribbon-modern">
                                        <div className="py-3 text-center">
                                            <i className="si si-plus fa-2x" />
                                            <br />
                                            <br />
                                            <p className="text-muted mb-3">
                                                {Translate(Message.Payment.AddCard)}
                                            </p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="col-12 form-group">
                                <span>
                                    {Translate(Message.Payment.ConfirmCode)}
                                </span>
                                <input className="form-control" name="cvv" onChange={evt => handleChange(evt)} />
                            </div>
                        </div>
                    </div>
                    : ""}
                <div className="col-md-12">
                    <table className="table table-hover">
                        {internationalCarrier && internationalCarrier.quotationId ?
                            <tbody>
                                <tr>
                                    <td>{Translate(Message.Services)}</td>
                                    <td>{internationalCarrier.name}</td>
                                </tr>
                                <tr>
                                    <td>{Translate(Message.Term)}</td>
                                    <td>{internationalCarrier.transit_days}</td>
                                </tr>
                                <tr>
                                    <td>{Translate(Message.Freight)}</td>
                                    <td>{ProcessCurrency()}{change && MoneyMask(internationalCarrier.freight_final, 2)}</td>
                                </tr>
                                <tr>
                                    <td>{Translate(Message.Taxes)}</td>
                                    <td>{ProcessCurrency()}{change && MoneyMask(internationalCarrier.tax_final, 2)}</td>
                                </tr>
                                <tr>
                                    <td>{Translate(Message.Insurance)}</td>
                                    <td>{ProcessCurrency()}{change && MoneyMask(internationalCarrier.insurance_final, 2)}</td>
                                </tr>
                                <tr>
                                    <td>Total</td>
                                    {internationalCarrier.customTotalPrice != internationalCarrier.totalPrice ?
                                        <td>{ProcessCurrency()}{change && MoneyMask(internationalCarrier.customTotalPrice, 2)}</td>
                                        :
                                        <td>{ProcessCurrency()}{change && MoneyMask(internationalCarrier.currency_payment_amount, 2)}</td>
                                    }

                                </tr>
                            </tbody>
                            : ""}
                        {nationalCarrier && nationalCarrier.serviceValue ?
                            <tbody>
                                <tr>
                                    <td>{Translate(Message.Services)}</td>
                                    <td>{nationalCarrier.name}</td>
                                </tr>
                                <tr>
                                    <td>{Translate(Message.Term)}</td>
                                    <td>{nationalCarrier.deadline}</td>
                                </tr>
                                <tr>
                                    <td>{Translate(Message.CollectionDate)}</td>
                                    <td>{nationalCarrier.collectDate}</td>
                                </tr>

                                <tr>
                                    <td>{Translate(Message.Freight)}</td>
                                    <td>R${MoneyMask(nationalCarrier.freight, 2)}</td>
                                </tr>
                                <tr>
                                    <td>{Translate(Message.Taxes)}</td>
                                    <td>R${MoneyMask(nationalCarrier.taxCost, 2)}</td>
                                </tr>
                                <tr>
                                    <td>Total</td>
                                    <td>R${MoneyMask(nationalCarrier.totalPrice, 2)}</td>
                                </tr>
                            </tbody>
                            : ""}
                    </table>
                </div>
                <div className="col-2"></div>
                <div className="col-8">
                    <button className="btn btn-block btn-hero-lg btn-hero-success" onClick={() => confirmRequest()}>
                        {Translate(Message.ConfirmRequest)} <i className="si si-check" />
                    </button>
                </div>
                <div className="col-2"></div>
            </div>
            <CreditCardModal
                show={showModal}
                onHide={() => setShowModal(false) | loadCreditCards()} />
        </Modal>
    );
}
